import React, { useState } from "react";
import { Progress } from "antd";
import { Rate } from "antd";
import { ReactComponent as Star } from "../../../assets/img/icons/star-1.svg";
import Button from "../../shared/Button";
import PlaceRateModal from "./PlaceRateModal";
import PersianNumber from "../../shared/PersianNumber";

const PlaceRate = ({inforesidencedetail}) => {
  const [RateModal, setRateModal] = useState(false)
  const customIcons = {
    1: <Star fill="#D9D9D9" />,
    2: <Star fill="#D9D9D9" />,
    3: <Star fill="#D9D9D9" />,
    4: <Star fill="#D9D9D9" />,
    5: <Star fill="#D9D9D9" />
  };
  function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
  return (
    <div className="PlaceRate ">
      <div className=" font-[400] text-[#292D32] text-[18px]">
        <span className="font-[900] text-[36px] ml-[5px]"><PersianNumber number={round(inforesidencedetail.rating_value,1)}/></span>
        از ۵
      </div>
      <div className="flex items-center  mb-[27px]">
        <Rate
          defaultValue={round(inforesidencedetail.rating_value,1)}
          disabled
          allowHalf
          //character={({ index }) => customIcons[index + 1]}
        />
        <div className="mr-[10px] font-[500] text-[#797D82] text-[14px]">
          از مجموعه نظر 57 نفر
        </div>
      </div>
      <div>
      <p className="font-[700] text-[#292D32] text-[18px] mb-[8px] ">
      نظافت :
      </p>
      <div className="flex items-center">
        <Progress
          percent={inforesidencedetail.rating.cleanliness * 20}
          trailColor="#EEF3F5"
          strokeColor="#00A6A6"
          strokeWidth={20}
          showInfo={false}
        />
        <p className="mr-[8px] font-[700] text-[#292D32] text-[14px]"><PersianNumber number={round(inforesidencedetail.rating.cleanliness,1)} /></p>
      </div>
      </div>
      <div>
      <p className="font-[700] text-[#292D32] text-[18px] mb-[8px] mt-[27px]">
      کیفیت میزبانی :
      </p>
      <div className="flex items-center">
        <Progress
          percent={inforesidencedetail.rating.hosting_quality * 20}
          trailColor="#EEF3F5"
          strokeColor="#00A6A6"
          strokeWidth={20}
          showInfo={false}
        />
        <p className="mr-[8px] font-[700] text-[#292D32] text-[14px]"><PersianNumber number={round(inforesidencedetail.rating.hosting_quality,1)}/> </p>
      </div>
      </div>
      <div>
      <p className="font-[700] text-[#292D32] text-[18px] mb-[8px] mt-[27px]">
      موقعیت مکانی :
      </p>
      <div className="flex items-center">
        <Progress
          percent={inforesidencedetail.rating.location * 20}
          trailColor="#EEF3F5"
          strokeColor="#00A6A6"
          strokeWidth={20}
          showInfo={false}
        />
        <p className="mr-[8px] font-[700] text-[#292D32] text-[14px]"><PersianNumber number={round(inforesidencedetail.rating.location,1)} /></p>
      </div>
      </div>
      {/* <div >
      <p className="font-[700] text-[#292D32] text-[18px] mb-[8px] mt-[27px]">
      تطابق با تصاویر :
      </p>
      <div className="flex items-center">
        <Progress
          percent={4.2 * 20}
          trailColor="#EEF3F5"
          strokeColor="#00A6A6"
          strokeWidth={20}
          showInfo={false}
        />
        <p className="mr-[8px] font-[700] text-[#292D32] text-[14px]">4.2</p>
      </div>
      </div> */}
      <div>
      <p className="font-[700] text-[#292D32] text-[18px] mb-[8px] mt-[27px]">
      ارزش نسبت به قیمت:
      </p>
      <div className="flex items-center">
        <Progress
          percent={inforesidencedetail.rating.value_for_money * 20}
          trailColor="#EEF3F5"
          strokeColor="#00A6A6"
          strokeWidth={20}
          showInfo={false}
        />
        <p className="mr-[8px] font-[700] text-[#292D32] text-[14px]"><PersianNumber number={round(inforesidencedetail.rating.value_for_money,1)} /></p>
      </div>
      </div>
      <div>
      <p className="font-[700] text-[#292D32] text-[18px] mb-[8px] mt-[27px]">
      صحت مطالب :
      </p>
      <div className="flex items-center">
        <Progress
          percent={inforesidencedetail.rating.authenticity * 20}
          trailColor="#EEF3F5"
          strokeColor="#00A6A6"
          strokeWidth={20}
          showInfo={false}
        />
        <p className="mr-[8px] font-[700] text-[#292D32] text-[14px]"><PersianNumber number={round(inforesidencedetail.rating.authenticity,1)} /></p>
      </div>
      </div>
      <Button varient="outlined" fullwidth className='mt-[20px]' onClick={()=>setRateModal(true)} >
      ثبت امتیاز جدید
      </Button>
      {
        RateModal && <PlaceRateModal  closeModal={()=>setRateModal(false)} inforesidencedetail={inforesidencedetail}/>
      }
    </div>
  );
};

export default PlaceRate;